import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Link } from '~/components/Link'
import { TrackingLabel } from '~/components/layout/ProductTrackingIntegration'

/**
 * A media's name, wherever a table points at one — the deployment center's two tables.
 *
 * It exists because those built the same link twice: a real `href` so middle-click and "open in new tab"
 * work, a `preventDefault` so an ordinary click routes instead of reloading the app, and a
 * `stopPropagation` so clicking the name inside a clickable row does not also fire the row.
 *
 * `Link`'s own King blue and bold both stand: the name is what a reader scans a media table by. Nothing
 * forces the weight back down here, so the two Deployment center tables — where the media name is not the
 * first column — read the same as each other.
 */
export const MediaLink: FunctionComponent<{ name: string; path: string; trackingLabel: TrackingLabel; className?: string }> = ({ name, path, trackingLabel, className }) => {
  const navigate = useNavigate()

  return (
    // `inline-flex min-w-0` so the guard does not undo the ellipsis `Link` sets up for a long name.
    <span className={'inline-flex min-w-0'} onClick={(event) => event.stopPropagation()}>
      <Link
        className={className}
        label={name}
        href={path}
        icon={'open_in_new'}
        iconSize={'16px'}
        onClick={(event) => {
          event.preventDefault()
          navigate(path)
        }}
        trackingLabel={trackingLabel}
      />
    </span>
  )
}
